<template>
  <div class="fd-cert consultant-stat">
    <div class="fd-img">
      <img src="../../assets/images/cert.png" alt="" />
    </div>
    <p class="cert-text">
      Please provide feedback to enable <br />
      <span>
        CERTIFICATE
      </span>
      generation
    </p>
  </div>
</template>

<script>
export default {
  name: "certBanner"
};
</script>

<style scoped>
.consultant-stat {
  max-width: 1300px;
  margin: 0 auto;
}
.fd-cert {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: space-between;
  background-color: #01b55e;
  border-radius: 4px;
}
.cert-text {
  font-family: "Open Sans";
  margin: auto auto;
  font-size: 24px;
  text-align: left;
  letter-spacing: 1.2px;
  color: #ffffff;
  font-weight: 400;
}
.cert-text span {
  font-family: "Open Sans";

  margin: auto auto;
  font-size: 24px;
  text-align: left;
  letter-spacing: 1.2px;
  color: #ffffff;
  font-weight: 700;
}

@media only screen and (max-width: 600px) {
  .fd-cert {
    width: 100%;
    height: 142px;
    background-color: #01b55e;
    border-radius: 4px;
    padding: 1em;
  }
  .fd-img {
    display: none;
  }
  .cert-text {
    font-size: 18px;
  }
}
</style>
